import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { BookingResultsData } from "../../state/BookingDiagnostics/ResultsData";

const updateResultsData: Reducer<BookingResultsData> = (state: BookingResultsData = new BookingResultsData(), action: Action<ActionType, any>) => {
  switch (action.type) {
    case ActionType.BOOKING_DIAGNOSTICS_DATA_FETCHED:
      return { ...state, ...action.data };
    case ActionType.BOOKING_DIAGNOSTICS_LOGS_FETCHED:
      return {
        ...state,
        requestResponseData: action.data.requestResponseData,
        bookingResponse: state.bookingResponse || action.data.publicApiResponse,
      };
    case ActionType.BOOKING_DIAGNOSTICS_DATA_RESET:
      return new BookingResultsData();
    default:
      return state;
  }
};

export default updateResultsData;
